/* eslint-disable no-invalid-this */
const {
    EVENT_NAMES: { ORDER_DETAILS },
    ASYNC_PAGE_LOAD
} = require('analytics/constants');
const processEvent = require('analytics/processEvent');

class OrderConfirmationSOTBindings {
    static triggerSOTAsyncAnalytics = ({ eventType = ASYNC_PAGE_LOAD, ...data }) => {
        const eventData = {
            data: {
                ...data
            }
        };

        processEvent.process(eventType, eventData);
    };

    static cancelOrderModal = () => {
        const { CANCEL_ORDER_MODAL, REASONS } = ORDER_DETAILS;
        OrderConfirmationSOTBindings.triggerSOTAsyncAnalytics({
            pageType: CANCEL_ORDER_MODAL,
            pageTypeDetail: REASONS
        });
    };
}

module.exports = OrderConfirmationSOTBindings;
